import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { Injectable } from '@angular/core';
import { combineLatest, merge } from 'rxjs';
import { AuthService } from '../../../../core/services/auth.service';
import { CharterDAO } from '../../../../core/services/dao/charterDAO';
import { ConstantMan } from '../../../../core/services/constantMan';
import { map, take } from 'rxjs/operators';
import { ApiHelper } from '../../../../core/services/apiHelper';
import { environment } from '../../../../environments/environment';

@Injectable()
export class ChartersGridResolve implements Resolve<any> {
  constructor(
    private authService: AuthService,
    private charterDao: CharterDAO,
    private apiHelper: ApiHelper,
  ) {
    this.apiHelper.setEnvironment(environment.envName);
  }

  resolve(route: ActivatedRouteSnapshot) {
    let daysToLoad = 30;
    const status = route.params.status ? route.params.status : 'lead';
    const sessionResolve = this.authService.checkSession();
    const charterResolve = this.charterDao.loadByStatus(status, daysToLoad);
    return combineLatest([sessionResolve, charterResolve]).pipe(
      map(([sessionResolve, charterResolve]) => ({
        sessionResolve,
        charterResolve,
      })),
      take(1),
    );
  }
}
